import Comments from "./Comments";
import Recomended from "./Recomended";
import ContentBody from "./ContentBody";
import GoogleAd from "./GoogleAd";
import OfficialLinks from "./OfficialLinks";

import { pageStyle } from "../utils/styles";

function ArticleContent({ article, top }) {
  return (
    <>
      <GoogleAd section="leaderboard_lazy" />

      <div className="section two-column">
        <style jsx>{pageStyle}</style>
        <style jsx>{`
          .sticky {
            position: sticky;
            top: 2rem;
          }
        `}</style>
        <div id="review">
          <ContentBody __html={article.article} />
          <Comments />
        </div>
        <div className="sidebar-container">
          <div className="sticky">
            <GoogleAd section="sidebar1" />
            <Recomended items={top.articles.slice(0, 3)} />
            <GoogleAd section="sidebar2" />
            <Recomended items={top.articles.slice(3, 10)} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ArticleContent;
